import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { StringUtils } from '@manifoldxyz/js-ts-utils';
import { MediaDisplay } from '@manifoldxyz/react-component-library';
import useMainStore from '@/store/mainStore';
import MediaLightbox from './MediaLightbox';

export default function RedeemMedia() {
  const studioInstance = useMainStore((state) => state.studioInstance);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  const handleOpenLightbox = () => {
    setIsLightboxOpen(true);
  };

  const handleCloseLightbox = () => {
    setIsLightboxOpen(false);
  };

  // Handle keyboard events for accessibility
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleOpenLightbox();
      e.preventDefault();
    }
  };

  if (!studioInstance) {
    return (
      <Skeleton
        height="100%"
        width="100%"
      />
    );
  }

  const imageUrl =
    studioInstance.publicData.asset.image_preview || studioInstance.publicData.asset.image;
  const animationUrl =
    studioInstance.publicData.asset.animation_preview ||
    studioInstance.publicData.asset.animation_url;

  return (
    <div className="m-claim--relative m-claim--aspect-square m-claim--size-full">
      <div
        className={StringUtils.classnames(
          'm-claim--size-full',
          'm-claim--bg-transparent',
          'm-claim--p-0',
        )}
      >
        <MediaDisplay
          imageUrl={imageUrl}
          animationUrl={animationUrl}
        />
      </div>

      {/* Fullscreen button */}
      <button
        onClick={handleOpenLightbox}
        onKeyDown={handleKeyDown}
        className={StringUtils.classnames(
          'm-claim--absolute',
          'm-claim--bottom-4',
          'm-claim--right-4',
          'm-claim--p-2',
          'm-claim--bg-surface-primary',
          'm-claim--text-primary',
          'hover:m-claim--bg-surface-secondary',
          'm-claim--rounded-full',
          'm-claim--transition-all',
          'm-claim--duration-200',
          'm-claim--z-10',
          'm-claim--shadow-md',
          'm-claim--border',
          'm-claim--outline-none',
          'm-claim--focus:outline-none',
          'm-claim--focus:ring-2',
          'm-claim--focus:ring-primary/50',
          'm-claim--transition-transform m-claim--duration-200 m-claim--ease-in-out hover:m-claim--scale-110',
        )}
        aria-label="View fullscreen"
        tabIndex={0}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="m-claim--size-6"
        >
          <path
            d="M15 3H21M21 3V9M21 3L14 10M9 21H3M3 21V15M3 21L10 14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Media Lightbox */}
      <MediaLightbox
        isOpen={isLightboxOpen}
        onClose={handleCloseLightbox}
        // @warn: purposely showing full size original image and animation for the lightbox
        imageUrl={
          studioInstance.publicData.asset.image || studioInstance.publicData.asset.image_preview
        }
        animationUrl={
          studioInstance.publicData.asset.animation_url ||
          studioInstance.publicData.asset.animation_preview
        }
      />
    </div>
  );
}
